import React from "react";
import { cls } from "@wss/cls";
interface PlusFreeviewFinalAdProps {
  freeviewFinalAdTestId?: string;
}
const PlusFreeviewFinalAd = ({
  freeviewFinalAdTestId = ""
}: PlusFreeviewFinalAdProps) => {
  return <>
      <a href="/plus/" data-testid={freeviewFinalAdTestId}>
        <img className={cls("hidden", "md:block")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner_final.png" alt="Exclusive Plus Preview Ad! Keep Saving with Free Shipping! Sign up for Plus and keep enjoying free shipping and more." />
        <img className={cls("hidden", "xs:block", "md:hidden")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner-final-med.png" alt="Exclusive Plus Preview Ad! Keep Saving with Free Shipping! Sign up for Plus and keep enjoying free shipping and more." />
        <img className={cls("xs:hidden")} src="//cdnimg.webstaurantstore.com/uploads/design/2024/1/PlusPreview/banner-final-sm.png" alt="Exclusive Plus Preview Ad! Keep Saving with Free Shipping! Sign up for Plus and keep enjoying free shipping and more." />
      </a>
    </>;
};
export default PlusFreeviewFinalAd;